<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. الفلاتر وأزرار التحكم -->
    <div class="card shadow-sm mb-4 border-top-primary no-print">
      <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
        <h5 class="mb-0 fw-bold text-primary">
          <i class="fas fa-eye ms-2"></i> المراجعة البصرية (ترتيب المستويات)
        </h5>
        
        <!-- زر تفعيل التعديل المحمي -->
        <button 
          v-if="!isEditMode"
          @click="enableEditing" 
          class="btn btn-outline-danger fw-bold"
          :disabled="students.length === 0"
        >
          <i class="fas fa-lock ms-2"></i> فتح التعديل (Admin)
        </button>
        <button v-else @click="isEditMode = false" class="btn btn-danger text-white fw-bold">
          <i class="fas fa-lock-open ms-2"></i> إغلاق التعديل (تأمين)
        </button>

      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <!-- (نفس الفلاتر السابقة) -->
          <div class="col-md-3">
            <label class="form-label fw-bold">الفصل الدراسي</label>
            <select v-model="form.term" class="form-select">
              <option v-for="t in terms" :key="t.id" :value="t">{{ t.name }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label fw-bold">المجموعة</label>
            <select v-model="form.group" class="form-select">
              <option v-for="g in groups" :key="g.id" :value="g.id">{{ g.group_name }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <button @click="fetchData" class="btn btn-primary w-100 fw-bold" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
              جلب البيانات
            </button>
          </div>
          <div class="col-md-3">
             <button @click="printPage" class="btn btn-dark w-100" :disabled="students.length === 0">
               <i class="fas fa-print ms-2"></i> طباعة
             </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. مفتاح الألوان -->
    <div class="d-flex gap-3 mb-3 no-print justify-content-center small fw-bold">
        <span class="badge bg-success p-2"><i class="fas fa-check-circle"></i> ناجح صافي</span>
        <span class="badge bg-warning text-dark p-2"><i class="fas fa-exclamation-circle"></i> راسب في مادة</span>
        <span class="badge bg-orange text-white p-2"><i class="fas fa-exclamation-triangle"></i> راسب في مادتين</span>
        <span class="badge bg-danger p-2"><i class="fas fa-times-circle"></i> راسب (أكثر)</span>
    </div>

    <!-- 3. جدول العرض (قابل للسكرول مع هيدر ثابت) -->
    <div id="printMe" v-if="students.length > 0">
      
      <!-- حاوية الجدول مع تحديد الارتفاع لتفعيل السكرول -->
      <div class="table-scroll-container shadow-sm border rounded">
 <table class="table table-bordered text-center align-middle mb-0">
          
          <thead class="table-dark sticky-header">
            <tr>
              <!-- عمود الاختيار (يختفي في الطباعة) -->
              <th width="40px" class="no-print bg-dark">
                  <input type="checkbox" class="form-check-input" v-model="selectAll" @change="toggleSelectAll">
              </th>

           
              <th width="100px">سري</th>
   
              <!-- رؤوس المواد -->
              <th v-for="sub in subjects" :key="sub.id" class="small-th">
                  {{ sub.name }} <br> <span class="text-warning small">({{ sub.max }})</span>
              </th>
              <th width="100px" class="bg-secondary">المجموع</th>
              <th width="150px">الحالة</th>
            </tr>
          </thead>
          
          <tbody>
            <!-- 
                نضيف شرط الكلاس: d-print-none 
                إذا كان هناك عناصر محددة، وهذا الطالب ليس منهم
             -->
            <tr 
                v-for="(student, index) in students" 
                :key="student.id" 
                :class="[
                    getRowClass(student.fail_count),
                    {'d-print-none': selectedCount > 0 && !student.selected} 
                ]"
            >
              
              <!-- Checkbox الاختيار -->
              <td class="no-print">
                  <input type="checkbox" class="form-check-input" v-model="student.selected">
              </td>

         
              <td class="fw-bold font-monospace">{{ student.SecretKey }}</td>
     

              <!-- الدرجات -->
              <td 
                v-for="sub in subjects" 
                :key="sub.id" 
                class="p-1 position-relative"
                :class="getCellClass(student.grades_list[sub.code], sub.main, sub.max)"
              >
                  <span v-if="!isEditMode" class="d-block py-2">
                     {{ formatGrade(student.grades_list[sub.code]) }}
                  </span>
                  <input 
                    v-else
                    type="number" 
                    class="form-control text-center fw-bold p-1 border-0 shadow-none"
                    style="background: transparent;"
                    v-model.number="student.grades_list[sub.code]"
                    @blur="saveGrade(student, sub.code, student.grades_list[sub.code])"
                  >
              </td>

              <td class="fw-bold bg-white text-dark border border-2">{{ student.total_score }}</td>

              <td class="fw-bold small">
                  <span v-if="student.fail_count === 0">ناجح صافي</span>
                  <span v-else>راسب في ({{ student.fail_count }})</span>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';
import Swal from 'sweetalert2';

export default {
  name: "VisualGradeReview",
  data() {
    return {
      loading: false,
      isEditMode: false, // حالة التعديل
        selectAll: false, // حالة تحديد الكل
      terms: [], groups: [],
      students: [], subjects: [],
      form: { term: '', group: '' }
    };
  },
   computed: {
    // حساب عدد الطلاب المحددين
    selectedCount() {
        return this.students.filter(s => s.selected).length;
    }
  },
  mounted() {
    this.fetchInitData();
  },
  methods: {
    // ... (دوال الجلب كما هي) ...
    async fetchInitData() {
      try {
        const [t, g] = await Promise.all([api.get("/getterms"), api.get("/getgroups")]);
        this.terms = t.data; this.groups = g.data;
      } catch (e) {}
    },

    async fetchData() {
      this.loading = true;
        this.selectAll = false; // تصفير التحديد
      this.isEditMode = false; // غلق التعديل عند جلب بيانات جديدة
      try {
        const res = await api.get('/admin/visual-review', { params: this.form });
        this.students = res.data.students;
        this.subjects = res.data.subjects;
      } catch (e) { alert("خطأ"); } 
      finally { this.loading = false; }
    },

    // =============================================
    // 1. دالة تفعيل التعديل (بكلمة مرور)
    // =============================================
    async enableEditing() {
      const { value: password } = await Swal.fire({
        title: 'صلاحية الأدمن مطلوبة',
        text: "يرجى إدخال كلمة المرور لتفعيل التعديل المباشر",
        input: 'password',
        inputPlaceholder: 'كلمة المرور',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'فتح التعديل',
        cancelButtonText: 'إلغاء'
      });

      if (password) {
        // هنا يفضل إرسال الباسوورد للباك اند للتحقق
        // ولكن للتبسيط سأفترض تحقق محلي أو يمكنك عمل API للتحقق
   
        try {
        //    await api.post('/check-admin-password', { password });
           this.isEditMode = true;
        //    Swal.fire('تم', 'تم تفعيل وضع التعديل', 'success');
        } catch(e) {
           Swal.fire('خطأ', 'كلمة المرور غير صحيحة', 'error');
        }
     

        // محاكاة بسيطة (استبدلها بالتحقق الحقيقي)
        if (password === '123456') { // ضع الباسورد الخاص بك هنا مؤقتاً
           this.isEditMode = true;
           const Toast = Swal.mixin({ toast: true, position: 'top-end', showConfirmButton: false, timer: 3000 });
           Toast.fire({ icon: 'success', title: 'تم تفعيل وضع التعديل' });
        } else {
           Swal.fire('خطأ', 'كلمة المرور غير صحيحة', 'error');
        }
      }
    },

    // =============================================
    // 2. دالة الحفظ المباشر عند التعديل
    // =============================================
    async saveGrade(student, colName, value) {
        // لا تفعل شيئاً إذا لم نكن في وضع التعديل
        if(!this.isEditMode) return;

        try {
             // استخدام نفس دالة الحفظ الفردي التي أنشأناها سابقاً
             await api.post('/save-single-degree', {
                id: student.id,
                col_name: colName, // كود المادة (ar, en...)
                degree: value
            });
            
            // تحديث المجموع وحالة الرسوب محلياً (اختياري لتحسين العرض الفوري)
            // أو إعادة طلب البيانات fetchData()
            
        } catch(e) {
            Swal.fire({ toast: true, position: 'top-start', icon: 'error', title: 'فشل الحفظ', showConfirmButton: false, timer: 1500 });
        }
    },
   toggleSelectAll() {
        this.students.forEach(s => s.selected = this.selectAll);
    },

    // دوال التنسيق والألوان
    getRowClass(failCount) {
        if (failCount === 0) return 'row-success';
        if (failCount === 1) return 'row-warning';
        if (failCount === 2) return 'row-orange';
        return 'row-danger';
    },

    getCellClass(degree, min, max) {
        if (degree == -1) return 'bg-secondary text-white'; 
        if (degree < min && degree >= 0) return 'bg-danger text-white fw-bold'; 
        if (degree == max) return 'text-success fw-bold border-success border-2'; 
        return '';
    },

    formatGrade(val) {
        if(val == -1) return 'غ';
        return val;
    },

    printPage() { this.$htmlToPaper("printMe"); }
  }
};
</script>

<style scoped>
.border-top-primary { border-top: 4px solid #0d6efd; }
.bg-orange { background-color: #fd7e14; }

/* 1. تنسيق الحاوية القابلة للسكرول */
.table-scroll-container {
    max-height: 75vh; /* أقصى ارتفاع للجدول */
    overflow-y: auto; /* تفعيل السكرول العمودي */
    position: relative;
}

/* 2. تثبيت الهيدر (Sticky Header) */
.sticky-header th {
    position: sticky;
    top: 0;
    z-index: 10; /* ليظهر فوق محتوى الجدول */
    box-shadow: 0 2px 2px -1px rgba(0,0,0,0.4); /* ظل خفيف للفصل */
    background-color: #212529; /* لون الخلفية ضروري جداً حتى لا يظهر المحتوى تحته */
    color: white;
}

/* تنسيقات الألوان للصفوف */
.row-success td { background-color: #f0fff4; }
.row-warning td { background-color: #fffbeb; }
.row-orange  td { background-color: #fff5e6; }
.row-danger  td { background-color: #fef2f2; }

/* تنسيقات الطباعة */
@media print {
   /* .no-print { display: none !important; } */
    
    /* 
       هذا الكلاس السحري:
       يخفي الصف في الطباعة فقط إذا لم يكن محدداً 
    */
    /* .d-print-none { display: none !important; }  */

    .table-scroll-container { max-height: none !important; overflow: visible !important; border: none !important; }
    .sticky-header th { position: static !important; }
    
    /* إظهار الألوان */
    .row-success td { background-color: #f0fff4 !important; -webkit-print-color-adjust: exact; }
    .row-warning td { background-color: #fffbeb !important; -webkit-print-color-adjust: exact; }
    .row-orange  td { background-color: #fff5e6 !important; -webkit-print-color-adjust: exact; }
    .row-danger  td { background-color: #fef2f2 !important; -webkit-print-color-adjust: exact; }
    .bg-danger { background-color: #dc3545 !important; color: white !important; -webkit-print-color-adjust: exact; }
    .bg-secondary { background-color: #6c757d !important; color: white !important; -webkit-print-color-adjust: exact; }
    .table-bordered th, .table-bordered td { border: 1px solid #000 !important; }
}
.border-top-primary { border-top: 4px solid #0d6efd; }
.bg-orange { background-color: #fd7e14; }
.table-scroll-container { max-height: 75vh; overflow-y: auto; position: relative; }
.sticky-header th { position: sticky; top: 0; z-index: 10; background-color: #212529; color: white; }
.row-success td { background-color: #f0fff4; }
.row-warning td { background-color: #fffbeb; }
.row-orange  td { background-color: #fff5e6; }
.row-danger  td { background-color: #fef2f2; }


</style>